export default __webpack_public_path__ + "static/media/satara_Mandave.bdb7342b.JPG";